import { z } from "zod";

import { machineSchema } from "./machine";
import { trackSchema } from "./track";
import { PORT_MAX, PORT_MIN } from "./constants";

const trackConfigurationSchema = trackSchema.extend({}).passthrough();

const machineSettingsSchema = z.object({}).passthrough();

export const fusionMachineRequestSchema = z.object({
	alias: z.string().optional(),
	description: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
	assetId: z.string().or(z.number()).optional(),
	plcVersion: z.string().nullish(),
	assignedOperator: z.string().optional(),
	capabilities: z.array(z.string()).optional(),
	tracks: z.array(trackConfigurationSchema).optional(),
	physicalMachineSettings: machineSettingsSchema.nullish(),
});

export const fusionMachineSchema = machineSchema.extend({
	// Fusion machines use base machineSchema fields (tracks, physicalMachineSettings)
});

export type FusionMachine = z.infer<typeof fusionMachineSchema>;
export type FusionMachineRequest = z.infer<typeof fusionMachineRequestSchema>;
